module.exports = __webpack_public_path__ + "img/fedyanin.04e2a2be.jpg";